export default class {
    constructor(apiService) {
        this.axiosInstance = apiService
    }

    getAll() {
        return this.axiosInstance.get(`sites`)
    }
}
